import upperFirst from 'lodash/upperFirst';

export const normalizeRelationList = (list = []) =>
  list.map(relation => ({
    label: upperFirst(relation),
    value: relation,
  }));



// WEBPACK FOOTER //
// ./src/utils/forms/EmergencyContact/normalizeRelationList.js